import { render, staticRenderFns } from "./ItemPage.vue?vue&type=template&id=fd9dc2ee&scoped=true&"
import script from "./ItemPage.vue?vue&type=script&lang=js&"
export * from "./ItemPage.vue?vue&type=script&lang=js&"
import style0 from "./ItemPage.vue?vue&type=style&index=0&id=fd9dc2ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd9dc2ee",
  null
  
)

export default component.exports